<template lang="pug" src="./navigation-desktop.pug"></template>

<script>
import Icon from 'components/icon/icon'

export default {
  data () {
    return {
      active: false,
      current: false
    }
  },
  computed: {
    links () {
      return this.$router.options.routes
    }
  },
  async created () {
    this.current = this.$store.state.route.name
  },
  methods: {
    trigger ({ going, direction }) {
      if (going === 'out' && direction === 'top') {
        this.active = true
      }
      if (going === 'in' && direction === 'bottom') {
        this.active = false
      }
    }
  },
  components: {
    Icon
  },
  watch: {
    '$store.state.route': function () {
      this.current = this.$store.state.route.name
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/navigation/navigation-desktop/navigation-desktop.vue